module.exports = __webpack_public_path__ + "assets/582211b43f7be4a25e4d329634fef646.svg";